/**
 * Product-aware FundElite branding surface rules.
 *
 * FundElite logos belong on Self Repair and general Agency/Admin/Platform shells.
 * FundGenius HQ is a separate product workspace and must never render FundEliteBrandMark.
 */

import {
  WORKSPACE_PRODUCTS,
  detectWorkspaceProduct,
  isFundGeniusHqPath,
} from '../config/productWorkspaceConfig';

export { isFundGeniusHqPath, WORKSPACE_PRODUCTS };

/**
 * @param {{ pathname?: string, hostname?: string }} [opts]
 * @returns {boolean}
 */
export function shouldRenderFundEliteBrandMark({
  pathname = typeof window !== 'undefined' ? window.location.pathname : '',
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
} = {}) {
  return detectWorkspaceProduct({ pathname, hostname }) !== WORKSPACE_PRODUCTS.FUNDGENIUS_HQ;
}

/**
 * @param {'self-repair' | 'agency-admin' | 'managed-client' | 'staff' | 'platform' | 'admin'} surface
 * @returns {'self-repair' | 'agency-admin'}
 */
export function getFundEliteBrandVariantForSurface(surface = 'self-repair') {
  if (surface === 'self-repair' || surface === 'managed-client') {
    return 'self-repair';
  }
  return 'agency-admin';
}

/**
 * True when AgencyWorkspaceLayout should hide FundElite chrome and defer to FundGeniusHQLayout.
 * @param {string} [pathname]
 */
export function isAgencyFundGeniusChromePassthrough(pathname = '') {
  return isFundGeniusHqPath(pathname);
}
